<template>
  <app-content>
    <form action="#">
      <div class="inner">
        <app-content-title :title="item.name" />
      </div>
      <app-tabs
          full-width
          :loadTab="params.tab"
          @appTabChanged="onAppTabChanged"
      >
        <div
            :title="translations.history"
        >
          <cron-runs
              :title="item.name"
              :code="code"
          />
        </div>
        <div :title="translations.properties">
          <app-settings @submit="submitForm" :disabled="pending">
            <app-settings-content>
              <app-settings-desc :title="translations.basicInfo">
                  <p>
                      <translate>Očekávaná délka běhu</translate>:
                      <br/>
                      {{ formItem.expectedRuntime | formatDuration }}
                  </p>
                  <p v-if="!pending">
                    <input
                        v-if="item.lastCronRunStatus !== 'running' ? true : false"
                        type="button"
                        :value="translations.start"
                        class="btn"
                        @click.stop="clickRun(item._id)"
                    >
                    <input
                        v-if="item.lastCronRunStatus === 'running' ? true : false"
                        type="button"
                        class="btn btn_orange"
                        :value="translations.unlock"
                        @click.stop="clickUnlock(item._id)"
                    >
                  </p>
              </app-settings-desc>

                <app-settings-options>
                  <app-settings-col class="field_left">
                    <app-input
                        required
                        :label="translations.name"
                        :error="errors.items.find(el => el.field === 'name')"
                        name="name"
                        v-model="formItem.name"
                    />
                  </app-settings-col>

                  <app-settings-col class="field_right">
                    <app-input
                        required
                        :label="translations.title"
                        :error="errors.items.find(el => el.field === 'title')"
                        name="title"
                        v-model="formItem.title"
                    />
                  </app-settings-col>

                  <app-settings-col class="field_left">
                    <app-input
                        required
                        type="number"
                        :label="translations.maxInactivityTime"
                        :error="errors.items.find(el => el.field === 'maximumInactivityTime')"
                        name="maximumInactivityTime"
                        v-model="formItem.maximumInactivityTime"
                    />
                  </app-settings-col>

                  <app-settings-col class="field_right">
                    <app-input
                        required
                        type="number"
                        :label="translations.maxRunPerDay"
                        :error="errors.items.find(el => el.field === 'maximumRunsPerDay')"
                        name="maximumRunsPerDay"
                        v-model="formItem.maximumRunsPerDay"
                    />
                  </app-settings-col>

                  <app-settings-col class="field_left">
                    <app-input
                        required
                        type="number"
                        :label="translations.maxRuntime"
                        :error="errors.items.find(el => el.field === 'maximumRuntime')"
                        name="maximumRuntime"
                        v-model="formItem.maximumRuntime"
                    />
                  </app-settings-col>

                  <app-settings-col class="field_right">
                    <app-settings-control class="checkbox">
                      <app-checkbox
                          name="enabled"
                          :title="translations.enabled"
                          :error="!!errors.first('enabled')"
                          v-model="formItem.enabled"
                      />
                    </app-settings-control>
                  </app-settings-col>

                  <app-settings-input
                      required
                      :error="errors.items.find(el => el.field === 'description')"
                      :label="translations.description"
                  >
                    <app-textarea
                      name="description"
                      v-model="formItem.description"
                    />
                  </app-settings-input>
                </app-settings-options>

              </app-settings-content>

            <app-settings-buttons :navLinkTitle="translations.list" :nav-link-to="{ name: 'crons' }">
              <app-content-save-button :disabled="pending" @click="disallowBack" />
            </app-settings-buttons>
          </app-settings>
        </div>
      </app-tabs>
    </form>
  </app-content>
</template>

<script>
import getItemDetailMixin from 'mixins/getItemDetailMixin'
import appTitleMixin from 'mixins/appTitleMixin'
import formatDateMixin from 'mixins/formatDateMixin'
import CronRuns from 'components/Cron/CronRuns'
import { mapActions } from 'vuex'

const itemDetailMixin = getItemDetailMixin({
  apiMethodsSuffix: 'Cron'
})

export default {
  name: 'cron',
  mixins: [
    formatDateMixin,
    itemDetailMixin,
    appTitleMixin()
  ],
  created() {
    this.params.tab = 0
  },
  components: {
    CronRuns
  },
  data() {
    return {
      code: null
    }
  },
  computed: {
    translations() {
      return {
        properties: this.$gettext('Vlastnosti'),
        basicInfo: this.$gettext('Základní údaje'),
        start: this.$gettext('Spustit'),
        unlock: this.$gettext('Odemknout'),
        name: this.$gettext('Název'),
        title: this.$gettext('Titulek'),
        maxInactivityTime: this.$gettext('Maximální doba neaktivity (sekundy)'),
        maxRunPerDay: this.$gettext('Maximální počet běhů za den'),
        maxRuntime: this.$gettext('Maximální délka běhu (sekundy)'),
        enabled: this.$gettext('Povoleno'),
        description: this.$gettext('Popis'),
        list: this.$gettext('Seznam'),
        history: this.$gettext('Historie')
      }
    },
    currentTitle() {
      return [
        { name: this.$gettext('Crony'), link: { name: 'crons' } },
        this.item.name
      ]
    },
    itemId() {
      return this.$route.params.id
    }
  },
  methods: {
    ...mapActions([
      'getCronCode',
      'getCron',
      'runCron',
      'unlockCron'
    ]),
    async fetchDetail() {
      this.getCron({ params: { id: this.itemId } })
    },
    async clickRun(id) {
      const result = await this.getCronCode()
      const run = await this.runCron({ params: { code: result.data.code, id } })
      run.then(
        this.fetchDetail()
      )
    },
    async clickUnlock(id) {
      const unlock = await this.unlockCron({ params: { id } })
      unlock.then(
        this.fetchDetail()
      )
    }
  }
}

</script>
